import React from 'react'

import {FieldViewProps} from "../../../../../render/view"
import TaskIcon from "../../../../../../gd-components/icons/task-icon/task-icon-ui5"

// const debug = "FieldTaskType_GlistView"
const debug = false

export default function FieldTaskType_GlistView(props: FieldViewProps) {

    const value : string = props.model[props.field.fieldId]

    const size = _.get(props.options,'size', 13)

    const taskType = gd.session.taskTypes.get(value)
    if (!taskType) {
        return null
    }

    const classes = Classes('flex-row-left-center txt-truncate', props.className)

    return (
        <div className={classes}>
            <TaskIcon
                className   = "m-r-5"
                taskType    = {taskType}
                size        = {size}
            />
            <div className="ui5-txt-default txt-truncate">
                {taskType.name}
            </div>
        </div>
    )
}
